console.log("bb-script.js");

// Mega Menu Hover Functionality
document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".mega-menu");

  megaMenus.forEach(function (megaMenu) {
    const summary = megaMenu.querySelector("summary");
    const content = megaMenu.querySelector(".mega-menu__content");

    if (!summary || !content) return;

    let hoverTimeout;

    // Show menu on hover
    megaMenu.addEventListener("mouseenter", function () {
      clearTimeout(hoverTimeout);
      megaMenu.setAttribute("open", "");
      content.style.opacity = "1";
      content.style.visibility = "visible";
      content.style.transform = "translateY(0)";
      content.style.pointerEvents = "auto";
    });

    // Hide menu on mouse leave with delay
    megaMenu.addEventListener("mouseleave", function () {
      hoverTimeout = setTimeout(function () {
        megaMenu.removeAttribute("open");
        content.style.opacity = "0";
        content.style.visibility = "hidden";
        content.style.transform = "translateY(-1rem)";
        content.style.pointerEvents = "none";
      }, 150); // Small delay to prevent flickering
    });

    // Keep menu open when hovering over content
    content.addEventListener("mouseenter", function () {
      clearTimeout(hoverTimeout);
    });

    // Hide menu when leaving content
    content.addEventListener("mouseleave", function () {
      hoverTimeout = setTimeout(function () {
        megaMenu.removeAttribute("open");
        content.style.opacity = "0";
        content.style.visibility = "hidden";
        content.style.transform = "translateY(-1rem)";
        content.style.pointerEvents = "none";
      }, 150);
    });

    // Prevent default click behavior
    summary.addEventListener("click", function (e) {
      e.preventDefault();
    });
  });
});
(() => {
  const theme = Shopify.theme.schema_name;
  if (theme !== "Dawn") return;

  const style = document.createElement("style");
  style.id = "bss-custom-style";
  style.textContent = `
  .price, .totals__total-value {
  visibility: visible;
  }
  `;
  document.head.appendChild(style);

  const customSelector = {
    collection: {
      selectorCard: ".card:not([bss-b2b-product-qb-id])",
      selectorPrice: ".price",
    },
    searchBar: {
      selectorCard: ".card:not([bss-b2b-product-qb-id])",
      selectorPrice: ".price",
    },
    product: { selectorForm: "product-info", selectorPrice: ".price" },
    cart: {
      selectorCard: '[id^="CartItem"].cart-item',
      selectorOriginPrice: ".price",
      selectorFinalLinePrice: ":not(*)",
      selectorSubtotalPrice: ".totals__total-value",
    },
  };

  let hasRun = false;
  function configTheme(config, { page }) {
    if (!hasRun) {
      const { getSelectors } = BSS_B2B.utils.SelectorsFactory;
      const collectionSels = getSelectors("ProductListSelectors")._selectorData
        .Default;
      collectionSels.search_bar_wrap = "div:has(> #ProductGridContainer)";
      hasRun = true;
    }
    return customSelector[page] ?? config;
  }
  window.BSS_B2B?.addFilter("custom:config_theme/installation", configTheme);
})();

// Company Popup Logic
document.addEventListener("DOMContentLoaded", function () {
  const quantityInputs = document.querySelectorAll('input[name="quantity"]');

  quantityInputs.forEach(function (input) {
    ["input", "change"].forEach((eventType) => {
      input.addEventListener(eventType, function () {
        const value = parseInt(this.value) || 0;
        const sectionId = this.id.replace("Quantity-", "");
        const popup = document.getElementById("company-popup-" + sectionId);
        const attributeInput = document.getElementById(
          "company-attribute-" + sectionId,
        );

        if (value > 2 && !attributeInput.value) {
          popup.style.display = "flex";
        }
      });
    });
  });

  // Handle popup buttons
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("company-popup__btn")) {
      const answer = e.target.dataset.answer;
      const popup = e.target.closest(".company-popup");
      const sectionId = popup.id.replace("company-popup-", "");
      const attributeInput = document.getElementById(
        "company-attribute-" + sectionId,
      );

      attributeInput.value = answer;
      popup.style.display = "none";
    }
  });

  // Prevent form submission if quantity > 2 and not answered
  document.addEventListener("submit", function (e) {
    if (e.target.matches('[data-type="add-to-cart-form"]')) {
      const quantityInput = e.target.querySelector('input[name="quantity"]');
      const attributeInput = e.target.querySelector(
        'input[name="attributes[Company]"]',
      );

      if (quantityInput && attributeInput) {
        const value = parseInt(quantityInput.value) || 0;
        if (value > 2 && !attributeInput.value) {
          e.preventDefault();
          const sectionId = quantityInput.id.replace("Quantity-", "");
          const popup = document.getElementById("company-popup-" + sectionId);
          popup.style.display = "flex";
        }
      }
    }
  });
});

(function () {
  function formatVATText(price, vat) {
    return `${price} (inc. ${vat}% VAT)`;
  }

  function extractPrice(text) {
    const match = text.match(/[^0-9\s]+[\d,.]+/);
    return match ? match[0] : null;
  }

  function getVAT(el) {
  let vat = 0;

  // PDP
  if (window.productVAT !== undefined) {
    vat = window.productVAT;
  }

  // Cart page
  const cartItem = el.closest(".cart-item");

  if (cartItem && cartItem.dataset.vat) {
    vat = cartItem.dataset.vat;
  }

  // PLP
  const card = el.closest("[data-vat]");

  if (card) {
    vat = card.getAttribute("data-vat") || vat;
  }

  return vat;
}

  function updateAllVAT() {
    /* -------------------------------
       CASE 1: .bss-b2b-price-has-vat
    --------------------------------*/
    const bssEls = Array.from(
      document.querySelectorAll(".bss-b2b-price-has-vat"),
    ).filter((el) => !el.closest(".totals__total-value"));

    bssEls.forEach((el) => {
      if (el.dataset.vatApplied === "true") return;

      const price = extractPrice(el.textContent);
      if (!price) return;

      const vat = getVAT(el);

      el.textContent = formatVATText(price, vat);
      el.dataset.vatApplied = "true";
    });

    /* -------------------------------
       CASE 2: .price_ex_tx (your HTML)
    --------------------------------*/
    const vatLabels = Array.from(
      document.querySelectorAll(".price_ex_tx"),
    ).filter((el) => !el.closest(".totals__total-value"));

    vatLabels.forEach((label) => {
      if (label.dataset.vatApplied === "true") return;

      const container =
  label.closest(
    ".bb-price-item--sale, .bb-price-item--regular"
  ) ||
  label.closest(".cart-item");

if (!container) return;

const priceEl =
  container.querySelector(".price-item--sale") ||
  container.querySelector(".price-item--regular") ||
  container.querySelector(".price-item");
      if (!priceEl) return;

      const price = extractPrice(priceEl.textContent);
      if (!price) return;

      const vat = getVAT(label);

      label.textContent = `(inc. ${vat}% VAT)`;
      label.dataset.vatApplied = "true";
    });
  }

  /* -------------------------------
     INITIAL LOAD (handles delay)
  --------------------------------*/
  let tries = 0;
  const interval = setInterval(() => {
    updateAllVAT();
    tries++;
    if (tries > 12) clearInterval(interval);
  }, 400);

  /* -------------------------------
     MUTATION OBSERVER (critical)
  --------------------------------*/
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;

    for (const m of mutations) {
      if (m.addedNodes.length || m.type === "characterData") {
        shouldRun = true;
        break;
      }
    }

    if (shouldRun) updateAllVAT();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
